import { render, staticRenderFns } from "./reUnsubscribe.vue?vue&type=template&id=20feb5ee&scoped=true&"
import script from "./reUnsubscribe.vue?vue&type=script&lang=ts&"
export * from "./reUnsubscribe.vue?vue&type=script&lang=ts&"
import style0 from "./reUnsubscribe.vue?vue&type=style&index=0&id=20feb5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20feb5ee",
  null
  
)

export default component.exports